import * as login_lang from './login';

export default {
    ...login_lang,
};
